import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { createBrowserHistory } from "history";
import { toastr } from "react-redux-toastr";
import { CouponDiscountCompComponent } from "./component";
import LoadingSpinner from "../../Loading/component";
import { useNavigate } from "react-router-dom";
import { onChange_CouponDescription_Step2 } from "../CouponCreate/action";
import { onChange_CouponImage_Step3 } from "../CouponCreate/action";
import { onChange_CouponDate_Step4 } from "../CouponCreate/action";
import { onChange_CouponDeeplink_Step5 } from "../CouponCreate/action";
import { onChange_CouponDiscountAmount_Step6 } from "../CouponCreate/action";
import { onChange_CouponCashbackAmount_Step7 } from "../CouponCreate/action";
import { onChange_CouponCashbackAmountType2_Step8 } from "../CouponCreate/action";
import { onChange_CouponCashbackAmountType_Step10 } from "../CouponCreate/action";
import { onChange_CouponVendingMachines_Step11 } from "../CouponCreate/action";
import { onChange_CouponAplicableItem_Step12 } from "../CouponCreate/action";
import { onChange_CouponPaymentGateway_Step13 } from "../CouponCreate/action";
import { onChange_CouponUseDuration_Step14 } from "../CouponCreate/action";
import { onChange_CouponLimit_Step15 } from "../CouponCreate/action";

const CouponDiscountCompContainer = (props) => {
  console.log("CouponAmount props", props);
  
  const [flatAmount, setFlatAmount] = useState("");
  const [activeBtn, setActiveBtn] = useState("percentage");
  const [maxDiscount, setMaxDiscount] = useState("");
  const navigate = useNavigate();

  // Handle flat amount change (for both flat and percentage max amount)
  const handleFlatAmountChange = (e) => {
    console.log("Flat amount change:", e.target.value);
    setFlatAmount(e.target.value);
  };

  // Handle max discount percentage change
  const handleMaxDiscountChange = (e) => {
    console.log("Max discount change:", e.target.value);
    setMaxDiscount(e.target.value);
  };

  // Handle max cashback for percentage (this is the maximum discount amount)
  const handleChangeMaxCashbackPercentage = (e) => {
    console.log("Max cashback percentage change:", e.target.value);
    setFlatAmount(e.target.value);
  };

  // Handle button click (flat/percentage)
  const handleBtnClick = (e, value) => {
    console.log("handleBtnClick:", value);
    setActiveBtn(value);
    // Clear values when switching between modes
    if (value === "flat") {
      setFlatAmount("");
    } else {
      setFlatAmount("");
      setMaxDiscount("");
    }
  };

  // Coupon creation step 8
  const couponCreationStep8 = () => {
    console.log("couponCreationStep8 called", localStorage.getItem("draftId"));

    // Validation based on active button type
    if (activeBtn === "flat") {
      if (!flatAmount || flatAmount === "") {
        toastr.warning("Please enter discount amount");
        return;
      }
      if (parseFloat(flatAmount) <= 0) {
        toastr.warning("Discount amount must be greater than 0");
        return;
      }
    }

    if (activeBtn === "percentage") {
      if (!maxDiscount || maxDiscount === "") {
        toastr.warning("Please enter discount percentage");
        return;
      }
      if (parseFloat(maxDiscount) <= 0) {
        toastr.warning("Discount percentage must be greater than 0");
        return;
      }
      if (!flatAmount || flatAmount === "") {
        toastr.warning("Please enter maximum discount amount");
        return;
      }
      if (parseFloat(flatAmount) <= 0) {
        toastr.warning("Maximum discount amount must be greater than 0");
        return;
      }
    }

    // Build discountDetails based on activeBtn
    let cashbackDetails = {};
    
    if (activeBtn === "percentage") {
      cashbackDetails = {
        flatTypeId: 2,
        maxCashback: parseFloat(flatAmount), // Maximum discount amount
        flatAmount: parseFloat(maxDiscount)  // Discount percentage
      };
    } else if (activeBtn === "flat") {
      cashbackDetails = {
        flatTypeId: 1,
        flatAmount: parseFloat(flatAmount),
      };
    }

    console.log("cashbackDetails to be sent to API:", cashbackDetails);
    
    props.getDataFromAPI(
      `/partner/api/v1/coupon/create/draft`,
      "POST",
      {
        step: 17,
        draftId: props.props && props.props.coupon.step1_draftId,
        cashbackDetails: cashbackDetails,
      },
      (response) => {
        console.log("API response step 8:", response);
        
        props.onChange_CouponDescription_Step2(response);
        props.onChange_CouponImage_Step3(response);
        props.onChange_CouponDate_Step4(response);
        props.onChange_CouponDeeplink_Step5(response);
        props.onChange_CouponDiscountAmount_Step6(response);
        props.onChange_CouponCashbackAmount_Step7(response);
        props.onChange_CouponCashbackAmountType2_Step8(response);
        props.onChange_CouponCashbackAmountType_Step10(response);
        props.onChange_CouponVendingMachines_Step11(response);
        props.onChange_CouponAplicableItem_Step12(response);
        props.onChange_CouponPaymentGateway_Step13(response);
        props.onChange_CouponUseDuration_Step14(response);
        props.onChange_CouponLimit_Step15(response);
        
        navigate("/home/couponfreegift");
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error("Error", err?.message || "Failed to create coupon.");
      },
      true
    );
  };

  return (
    <>
      <CouponDiscountCompComponent
        couponCreationStep8={couponCreationStep8}
        activeBtn={activeBtn}
        flatAmount={flatAmount}
        maxDiscount={maxDiscount}
        handleChangeMaxCashbackPercentage={handleChangeMaxCashbackPercentage}
        handleFlatAmountChange={handleFlatAmountChange}
        handleMaxDiscountChange={handleMaxDiscountChange}
        handleBtnClick={handleBtnClick}
      />
    </>
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
  onChange_CouponDescription_Step2,
  onChange_CouponImage_Step3,
  onChange_CouponDate_Step4,
  onChange_CouponDeeplink_Step5,
  onChange_CouponDiscountAmount_Step6,
  onChange_CouponCashbackAmount_Step7,
  onChange_CouponCashbackAmountType2_Step8,
  onChange_CouponCashbackAmountType_Step10,
  onChange_CouponVendingMachines_Step11,
  onChange_CouponAplicableItem_Step12,
  onChange_CouponPaymentGateway_Step13,
  onChange_CouponUseDuration_Step14,
  onChange_CouponLimit_Step15,
})(CouponDiscountCompContainer);